import React, { Component } from 'react';
import AD from 'react-google-publisher-tag';
import _ from 'lodash';
import './Standing.css';

class Standings extends Component {
  state = {
    teams: []
  }

  componentDidMount = () => {
      const standings = this.props.data.seasonData.standings;    
      this.setState({ 
        teams: standings.team,
        league: standings.league.leaguename
      });
  }

  render() {
    return (
      <div className="standings">
        <div className='standings-wrap'>
          <h3 className='standings-title site-border-color'>{`${new Date().getFullYear()} Standings`}</h3>
          <h4>{this.state.league}</h4>
          {this.state.teams.length? this.state.teams.map((item, i) => (
            <div className='team-stat' key={i}>
              <span className='team'>{`${i+1}. ${item.teamshortname}`}</span>
              <span className='score'>{`${item.wins} - ${item.losses}`}</span>
            </div>
          )) : <div /> }
        </div>
        <div className='rectangle-ad-container'>
          <AD path={_.get(this.props.data, 'metadataMap.squareAdTag')} dimensions={[[300, 250]]} />
        </div>
      </div>
    );
  }
}

export default Standings;
